import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Alert } from 'components';

const ReportLastDate = (props) => {
	const { date, dateEricsson } = props;

	const _renderMessage = () => {
		const finalDate = moment(date).format('yyyy-MM-DD HH:mm');
		let message = `Last data update: ${finalDate}`;
		if (dateEricsson) {
			const finalDateEricsson = moment(dateEricsson).format('yyyy-MM-DD HH:mm');
			message = `Last data updates: ${finalDate} (Huawei) ${finalDateEricsson} (Ericsson) `;
		}
		return message;
	};
	return (
		<Alert
			message={_renderMessage()}
		/>
	);
};

ReportLastDate.propTypes = {
	date: PropTypes.string.isRequired,
	dateEricsson: PropTypes.string
};

export default ReportLastDate;
